




















import Vue from 'vue';
import ReportControls, { ReportSpecByWeek, Account } from '@/components/ReportControls.vue';
import DailyBillingUnitChartTile from '@/components/dashboards/daily_bu_report/DailyBillingUnitChartTile.vue';
import DailyVolumePrediction from '@/components/dashboards/daily_bu_report/DailyVolumePrediction.vue';
import axios from 'axios';


interface DateRangeOptions {
  [year: number]: number[];
}

export default Vue.extend({
  name: 'DailyBillingUnitReport',
  components: {
    DailyBillingUnitChartTile,
    DailyVolumePrediction,
    ReportControls,
  },
  data() {
    return {
      dateOptions: {} as DateRangeOptions,
      spec: {} as ReportSpecByWeek,
      loading: true,
    };
  },
  computed: {
    dataUrl(): string {
      const BASE_URL = (process.env.NODE_ENV === 'production') ? '/api' : '//localhost:8000';
      const {depot, from, to, weekday_from, weekday_to} = this.spec;
      return `${BASE_URL}/reports/daily-billing-unit-dashboard/${depot}/${from.year}/${from.week}/${to.year}/${to.week}/${weekday_from}/${weekday_to}/`;
    },
  },
  watch: {
    async spec() {
      this.loading = true;
      const response = await axios.get(this.dataUrl, {
        params: {
          account_codes: this.spec.accountCodes.flatMap((a: Account) => a.codes),
        },
      });
      this.loading = false;
    },
  },
});
